// example: 21.06.2017, 07:32
var dateFormat = require('dateformat');
module.exports = {

    getCurDate() {

    },
    newDate(date) {
        var newDate = new Date(date);
        //newDate.setTime(newDate.getTime() - newDate.getTimezoneOffset() * 60 * 1000);
        return newDate;
    },

    // get date object and turn it to valid date representation
    fromDateToStr: function(date) {
        return dateFormat(date, "dd.mm.yyyy, 00:00");
    },

    fromDateToStrWithoutTime: function(date) {
        return dateFormat(date, "dd.mm.yyyy");
    },

    fromDateToStrWithTime: function(date) {
        return dateFormat(date, "dd.mm.yyyy, HH:MM");
    },

    fromDateToStrWithTimeForFileName: function(date) {
        return dateFormat(date, "dd.mm.yyyy_HH:MM");
    },

    // get date object from DB and turn in to valid date representation
    fromDBStrToStr: function(date) {
        return this.fromDateToStr(this.newDate(date));
    },

    fillDateFromMonthAndYear: function(dateOnlyMonthAndYear) {
        return `01.${dateOnlyMonthAndYear}, 00:00`
    },

    fromDBStrToStrWithoutTime: function(date) {
        return this.fromDateToStrWithoutTime(this.newDate(date));
    },

    // get date object from DB and turn in to valid date representation
    fromDBStrToStrWithTime: function(date) {
        return this.fromDateToStrWithTime(this.newDate(date));
    },

    // get date object from DB and turn in to valid date representation
    fromDBStrToDate: function(date) {
        return this.newDate(date);
    },

    fromDBStrToSpecialUiDate: function(date) {
        return dateFormat(this.newDate(date), "mmmm dd, yyyy");
    },

    // get valid date representation and turn it to date object
    fromStrToDate: function(date) {
        if (date == null)
            return null;

        if (this.validateDateFromClient(date)) {
            var pattern = /(\d{2})\.(\d{2})\.(\d{4})/;
            return this.newDate(date.replace(pattern, '$3.$2.$1'));
        } else {
            return this.newDate(date);
        }
    },

    fromStrToStrWithoutTime: function(date) {
        return date.replace(", 00:00", "");
    },

    fromStrWithTimeToDate: function(date) {
        var pattern = /(\d{2})\.(\d{2})\.(\d{4}), (\d{2}:\d{2})/;

        var date = this.newDate(date.replace(pattern, '$3.$2.$1 $4'));
        //date.setHours(date.getHours()-date.getTimezoneOffset()/60);
        return date;
    },

    // get date object and turn it into a valid db date
    fromDateToDBStr: function(date) {
        return dateFormat(date, "yyyy-mm-dd HH:MM");
    },

    fromDateToDBStrWithoutTime: function(date) {
        return dateFormat(date, "yyyy-mm-dd");
    },

    fromStrToDBStr: function(date) {
        return this.fromDateToDBStr(this.fromStrToDate(date));
    },

    fromSecondsToTime: function(secs) {
        var minutes = Math.floor(secs / 60);
        var hours = Math.floor(minutes / 60)
        minutes = minutes % 60;
        return pad(hours) + ":" + pad(minutes);

    },

    fromNumberToWeekDay: function(number) {
        return weekday[number];
    },

    validYearMonthFromClient: function(data) {
        if (!/^(1[0-2]|0[1-9]|[1-9])\/(20\d{2}|19\d{2})$/.test(data)) {
            console.log("regex doesn't match - " + data + " - MM/YYYY");
            return false;
        }
        return true;
    },

    validateDateFromClient: function(date) {
        if (!/^(\d{1,2}\.\d{1,2}\.\d{4}\, \d{2}\:\d{2})|(\d{1,2}\.\d{1,2}\.\d{4})$/.test(date)) {
            console.log("regex doesn't match");
            return false;
        }


        // Parse the date parts to integers
        var parts = date.split(".");
        var day = parseInt(parts[0], 10);
        var month = parseInt(parts[1], 10);
        var year = parseInt(parts[2], 10);

        var hours = 0;
        var minutes = 0;
        if (date.indexOf(",") > -1) {
            var time = date.split(",")[1];
            parts = time.split(":");
            hours = parts[0];
            minutes = parts[1];
        }

        // Check the ranges of month and year
        if (year < 1000 || year > (new Date().getFullYear() + 2) || month == 0 || month > 12 || hours > 24 || hours < 0 || minutes > 60 || minutes < 0) {
            console.log("something doesn't match");
            return false;
        }


        var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        // Adjust for leap years
        if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
            monthLength[1] = 29;

        // Check the range of the day
        return day > 0 && day <= monthLength[month - 1];
    }

}


var weekday = new Array(8);
weekday[1] = "Sunday";
weekday[2] = "Monday";
weekday[3] = "Tuesday";
weekday[4] = "Wednesday";
weekday[5] = "Thursday";
weekday[6] = "Friday";
weekday[7] = "Saturday";

function pad(num) {
    return ("0" + num).slice(-2);
}


// WEBPACK FOOTER //
// ./helpers/date.js